import { FC } from "react";

import { SvgIconConstituentValues } from "types/common";
export const ProductMediaIcon: FC<SvgIconConstituentValues> = ({
  fill,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect x="3" y="5" width="18" height="14" rx="2" fill={fill || "#646965"} />
    <circle cx="8" cy="12" r="2" fill="#fff" />
    <path d="M14 10L19 15H5L10 10L12 12L14 10Z" fill="#fff" />
  </svg>
);

// export const ProductMediaIcon: FC<SvgIconConstituentValues> = ({
//   fill,
//   ...props
// }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     {...props}
//   >
//     <path
//       d="M21.41 11.58L12.42 2.59C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.58 21.41C12.36 22.19 13.64 22.19 14.42 21.41L21.41 14.42C22.19 13.64 22.19 12.36 21.41 11.58ZM11 6C9.34 6 8 7.34 8 9C8 10.66 9.34 12 11 12C12.66 12 14 10.66 14 9C14 7.34 12.66 6 11 6Z"
//       fill={fill || "#646965"}
//     />
//   </svg>
// );
